import { render, staticRenderFns } from "./KpiSpacer.vue?vue&type=template&id=6911abbb&scoped=true&"
import script from "./KpiSpacer.vue?vue&type=script&lang=js&"
export * from "./KpiSpacer.vue?vue&type=script&lang=js&"
import style0 from "./KpiSpacer.vue?vue&type=style&index=0&id=6911abbb&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6911abbb",
  null
  
)

export default component.exports